var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.897 29.045 1.066 2.91A.634.634 0 0 1 1.633 2h4.446c.237 0 .46.135.566.343l9.37 18.96c.835 1.701 3.252 1.701 4.087 0l9.34-18.945a.638.638 0 0 1 .568-.343h.553a.43.43 0 0 1 .388.627L17.986 29.045c-.835 1.7-3.253 1.7-4.088 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVet);
export default __webpack_public_path__ + "static/media/VET.4c22e3a43dc3a54bdc95fc217d2181ce.svg";
export { ForwardRef as ReactComponent };